import { createDuck } from '@/utils/'
import { isObject } from '@/utils/utils'
import { fetchDoubleActInfo, sendGiftNew } from '@/services/api/home'
import { USER_STATUS, USER_TYPE_NEW, USER_TYPE_OLD } from '@/utils/const'
const { NO_JOIN, NO_AWARD, AWARDED, EXPIRED, INELIGIBLE, USED } = USER_STATUS

export const CACHE_NEW_KEY = 'double11-new'
export const CACHE_OLD_KEY = 'double11-old'
const STEP_MAP = {
  [NO_JOIN]: 1,
  [NO_AWARD]: 3,
  [AWARDED]: 3,
  [EXPIRED]: 4,
}
export const duck = createDuck({
  name: 'double11Duck',
  initialState: {
    activityStatus: 0,
    showAct: false,
    useType: null,
    couponPic: null,
    activityInfo: null,
    userInfo: null,
    step: null,
    visible: false,
  },
  actions: {
    changeVisible(val) {
      return dispatch => {
        dispatch(
          duck.change({
            visible: val,
          }),
        )
      }
    },

    //初始化活动信息
    initActInfo() {
      return async dispatch => {
        const { data } = await fetchDoubleActInfo()
        const { activityInfo, userInfo, hasGift, couponPic } = data || {}
        const { state } = isObject(userInfo) ? userInfo : { state: null }
        const { nowTime, to, from } = isObject(activityInfo)
          ? activityInfo
          : { nowTime: 0, from: 0, to: 0 }
        const _now = new Date().getTime()
        if (nowTime < from || nowTime >= to) {
          dispatch(
            duck.change({
              activityStatus: 1,
              showAct: false,
              activityInfo: { ...activityInfo, _diff: nowTime - _now },
            }),
          )
          return
        }
        //老用户 送 优惠券(state //-10,2,不符合活动，已使用)
        if (state === INELIGIBLE || state === USED) {
          dispatch(
            duck.change({
              activityStatus: 1,
              showAct: couponPic,
              useType: USER_TYPE_OLD,
              activityInfo: { ...activityInfo, _diff: nowTime - _now },
              couponPic,
            }),
          )
        } else {
          //新用户
          dispatch(
            duck.change({
              activityStatus: 1,
              useType: USER_TYPE_NEW,
              userInfo: { ...userInfo },
              showAct:
                hasGift &&
                nowTime <= to &&
                (state === NO_JOIN || state === NO_AWARD || state === AWARDED || state === EXPIRED),
              activityInfo: { ...activityInfo, _diff: nowTime - _now },
              step: STEP_MAP[state],
            }),
          )
        }
      }
    },

    //领取奖品
    awardGift() {
      return async dispatch => {
        const { data, error } = await sendGiftNew()

        if (!error) {
          const { status, userInfo } = data
          if (status === 1) {
            dispatch(
              duck.change({
                step: 2,
                userInfo: { ...userInfo },
              }),
            )
          }
          // 赠品池没奖品了
          if (status === -1) {
            dispatch(
              duck.change({
                step: 4,
              }),
            )
          }
        }
      }
    },
  },
})
